import { boolean, object, SchemaOf } from "yup";
import { sanitizeFileName } from "@epcnetwork/core-ui-kit";

import { emailColumnValidation, headersValidation } from "utils";
import { requiredFieldText } from "constants/form.constants";
import { csvFormat, txtFormat } from "constants/file.constants";
import { OverlapInsightFileData, OverlapInsightValues } from "./overlap-insight.types";

export const supportedFormats = [csvFormat, txtFormat].flat();

export const getInitialData = (item: File): OverlapInsightFileData => ({
  fileName: sanitizeFileName(item.name),
  emailIndex: -1,
  headers: [],
  hasHeaders: false,
});

export const validationSchema: SchemaOf<OverlapInsightValues> = object({
  headerValues: object({
    emailIndex: emailColumnValidation(),
    headers: headersValidation(),
    hasHeaders: boolean().required(requiredFieldText),
  }).required(requiredFieldText),
});
